import { Injectable } from '@angular/core';
import { PackingBoxViewAuthService } from '../../../views/packing-box/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FiltersPackingBoxAuthService extends PackingBoxViewAuthService {
  override createLabel(): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'QualityControl',
      'QualityControlInspector',
      'LabelOperator',
      'FiltersLabelOperator',
      'FiltersQualityControl',
    ]);
  }

  override createCustomLabel(): boolean {
    return !this.onlyViewers(['Filter']);
  }
}
